package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.SendInvitationPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = SendInvitationPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationSendInvitationPresenterFactory {
  @Provides
  @IntoSet
  public fun provideSendInvitationPresenterFactoryFactoryMultibinding(sendInvitationPresenterFactory: SendInvitationPresenterFactory): Presenter.Factory = sendInvitationPresenterFactory
}
